<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import DescriptionFilter from "../../filterImplementations/DescriptionFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<DescriptionFilter>,
    required: true,
  },
});
const text = computed(() => {
  return props.filter.searchText;
});
</script>

<style lang="scss" scoped></style>
